import 'jquery';
import 'slick-carousel';
import initFeatherlight from 'featherlight'
import './navigation';
import './search';
// Blocks are bulk imported at compile time

initFeatherlight();

jQuery(function($) {
    // Do stuff
})
